<template>
  <section class="sectionBox">
    <div class="previewBox">
      <div class="leftBox">
        <img class="groupImage" :src="groupPreview.profileImage" />
      </div>
      <div class="rightBox">
        <div class="topBox">
          <p class="groupTitle">{{ groupPreview.name }}</p>
          <button class="closeEdit" @click="closePreview"></button>
        </div>
        <p class="memberNum">
          {{ groupPreview.userCount }} member<span
            v-if="groupPreview.userCount !== 1"
            >s</span
          >
        </p>
        <p class="description" v-if="!groupPreview.description">
          Join this group now to meet people and make new friends!
        </p>
        <p class="description">{{ groupPreview.description }}</p>
        <div class="memberNum noInterests" v-if="interests.length == 0">
          No Interests
        </div>
        <div v-else class="interestList">
          <div v-for="(interest, index) in interests" :key="index">
            <Interest :icon="interest.unicode" :interest="interest.name" />
          </div>
        </div>
      </div>
    </div>
    <template v-if="checkNotInGroup">
      <button
        v-if="
          groupPreview.privacyType == 'public' || groupPreview.type == 'courses'
        "
        class="joinButton"
        @click="joinGroup"
      >
        Join Group
      </button>
      <button
        v-else-if="groupPreview.privacyType == 'private' && hasRequested"
        class="joinButton"
        @click="cancelRequest"
      >
        Cancel Join Request
      </button>
      <button v-else class="joinButton" @click="requestGroup">
        Request to Join
      </button>
    </template>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import db from "@/db";
import firebase from "@/firebase";
import Interest from "@/components/profile/Interest";

export default {
  components: {
    Interest,
  },

  data: () => ({
    hasInterests: false,
    interests: [],
  }),
  created() {
    this.groupPreview.userCount = this.groupPreview.userCount
      ? this.groupPreview.userCount
      : 0;
  },

  mounted() {
    if (this.groupPreview.interests) {
      this.interests = this.groupPreview.interests;
    }
    console.log(this.groupPreview);
  },

  watch: {},

  computed: {
    ...mapState("messageBoard", ["searchingGroup", "groupPreview"]),
    ...mapState("user", ["user"]),
    ...mapState("groupPreview", ["defaultGroupImage"]),
    hasRequested() {
      if (this.groupPreview.requests) {
        let index = this.groupPreview.requests.findIndex(
          (user) => user.user_id === this.user.id
        );
        return index !== -1;
      }
      return null;
    },
    checkNotInGroup() {
      if (
        this.groupPreview.school_id !== this.user.school_id &&
        !this.groupPreview.isGlobal
      ) {
        return false;
      }
      if (this.groupPreview.users) {
        if (
          this.groupPreview.users.findIndex(
            (x) => x.user_id === this.user.id
          ) !== -1 &&
          this.user.groups.findIndex((x) => x.id === this.groupPreview.id) !==
            -1
        ) {
          return false;
        }
      }
      return true;
    },
  },

  methods: {
    ...mapActions("messageBoard", ["setSearchGroup", "subscribeToTopic"]),
    ...mapActions("user", ["updateUserGroups"]),
    closePreview() {
      this.$store.commit("messageBoard/setSearchGroup", false);
    },
    joinGroup() {
      let data = {
        name: this.user.firstName + " " + this.user.lastName,
        profileImage: this.user.profileImage,
        user_id: this.user.id,
      };
      //this.groupPreview.users.push(data);
      this.groupPreview.recentPosts = !this.groupPreview.recentPosts
        ? []
        : this.groupPreview.recentPosts;

      if (
        this.user.allGroups.findIndex((x) => x.id === this.groupPreview.id) ===
        -1
      ) {
        if (this.groupPreview.type == "courses") {
          this.user.courses.push({
            name: this.groupPreview.name,
            id: this.groupPreview.id,
            lastVisited: Date.now(),
            notificationsEnabled: true,
            subject: this.groupPreview.subject,
            recentPosts: this.groupPreview.recentPosts,
            users: this.groupPreview.users,
            hasSeenLastPost: this.groupPreview.hasSeenLastPost,
            type: "courses",
          });
          this.user.course_ids.push(this.groupPreview.id);
        } else if (this.groupPreview.type == "faculties") {
          this.user.faculties.push({
            name: this.groupPreview.name,
            id: this.groupPreview.id,
            lastVisited: Date.now(),
            notificationsEnabled: true,
            recentPosts: this.groupPreview.recentPosts,
            users: this.groupPreview.users,
            hasSeenLastPost: this.groupPreview.hasSeenLastPost,
            type: "faculties",
          });
          this.user.faculty_ids.push(this.groupPreview.id);
        } else {
          this.user.groups.push({
            name: this.groupPreview.name,
            id: this.groupPreview.id,
            lastVisited: Date.now(),
            notificationsEnabled: true,
            recentPosts: this.groupPreview.recentPosts,
            users: this.groupPreview.users,
            hasSeenLastPost: this.groupPreview.hasSeenLastPost,
            type: "groups",
          });
          this.user.group_ids.push(this.groupPreview.id);
        }
      }
      if (
        this.groupPreview.users.findIndex((x) => x.id === this.user.id) === -1
      ) {
        db.collection(this.groupPreview.type)
          .doc(this.groupPreview.id)
          .update({
            users: firebase.firestore.FieldValue.arrayUnion(data),
            userCount: this.groupPreview.users.length + 1,
          });
      }

      this.$store.commit("messageBoard/setGroupId", this.groupPreview.id);
      this.$store.commit("messageBoard/setGroupName", this.groupPreview.name);
      this.$store.commit("messageBoard/setGroupType", this.groupPreview.type);
      this.$store.commit("messageBoard/setCurGroup", this.groupPreview);
      this.$store.commit("user/setUser", this.user);
      this.updateUserGroups();
      this.subscribeToTopic({ groupId: this.groupPreview.id, user: this.user });

      var joinedContent =
        this.user.firstName + " " + this.user.lastName + " joined the group";

      this.addUserJoinedGroupPost(joinedContent, this.groupPreview);

      this.$router.push({
        name: "MessageBoard",
        params: {
          name: this.groupPreview.name,
          id: this.groupPreview.id,
          type: this.groupPreview.type,
        },
      });
      this.$store.commit("messageBoard/setGroupPreview", undefined);
      this.$store.commit("messageBoard/setSearchGroup", false);
    },
    requestGroup() {
      var requestPost = {
        content: this.user.firstName + " " + this.user.lastName,
        created_at: Date.now(),
        isGroupRequest: true,
        profileImage: this.user.profileImage,
        user_id: this.user.id,
        chat_id: this.groupPreview.id,
      };
      const id = "p" + db.collection("posts").doc().id;
      db.collection("posts")
        .doc(id)
        .set(requestPost);
      delete requestPost.chat_id;
      requestPost.id = id;
      this.groupPreview.recentPosts.push(requestPost);
      while (this.groupPreview.recentPosts.length > 25) {
        this.groupPreview.recentPosts.splice(0, 1);
      }
      var request = {
        name: this.user.firstName + " " + this.user.lastName,
        created_at: requestPost.created_at,
        profileImage: this.user.profileImage,
        user_id: this.user.id,
        post_id: id,
      };
      if (!this.groupPreview.requests) {
        this.groupPreview.requests = [];
      }
      this.groupPreview.requests.push(request);
      db.collection("groups")
        .doc(this.groupPreview.id)
        .update({
          recentPosts: this.groupPreview.recentPosts,
          requests: this.groupPreview.requests,
        });
      this.$store.commit("messageBoard/setGroupPreview", this.groupPreview);
      var requestGroup = firebase
        .functions()
        .httpsCallable("sendPostRequestNotification");
      requestGroup({
        id: this.groupPreview.id,
        groupName: this.groupPreview.name,
        content:
          this.user.firstName + " " + this.user.lastName + " requested to join",
      });
    },
    cancelRequest() {
      let index = this.groupPreview.requests.findIndex(
        (user) => user.user_id === this.user.id
      );
      const post_id = this.groupPreview.requests[index].post_id;
      this.groupPreview.requests.splice(index, 1);
      let postIndex = this.groupPreview.recentPosts.findIndex(
        (post) => post.id === post_id
      );
      this.groupPreview.recentPosts.splice(postIndex, 1);
      db.collection("groups")
        .doc(this.groupPreview.id)
        .update({
          recentPosts: this.groupPreview.recentPosts,
          requests: this.groupPreview.requests,
        });
      db.collection("posts")
        .doc(post_id)
        .delete();
      db.collection("posts")
        .where("chat_id", "==", this.groupPreview.id)
        .where("created_at", "<", this.groupPreview.recentPosts[0].created_at)
        .limit(1)
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            var post = doc.data();
            console.log(post);
            delete post.chat_id;
            post.id = doc.id;
            this.groupPreview.recentPosts.unshift(post);
            db.collection("groups")
              .doc(this.groupPreview.id)
              .update({
                recentPosts: this.groupPreview.recentPosts,
              });
            this.$store.commit(
              "messageBoard/setGroupPreview",
              this.groupPreview
            );
          });
        });
    },
    addUserJoinedGroupPost(content, group) {
      const id = "p" + db.collection("posts").doc().id;
      db.collection("posts")
        .doc(id)
        .set({
          content: content,
          chat_id: group.id,
          created_at: Date.now(),
        });
      this.groupPreview.recentPosts.push({
        content: content,
        chat_id: group.id,
        created_at: Date.now(),
        id: id,
      });
      while (this.groupPreview.recentPosts.length > 25) {
        this.groupPreview.recentPosts.splice(0, 1);
      }

      db.collection(this.groupPreview.type)
        .doc(this.groupPreview.id)
        .update({
          recentPosts: this.groupPreview.recentPosts,
        });
    },
    getGroupName(group) {
      return group.name;
    },
  },
};
</script>

<style scoped>
.sectionBox {
  background-color: white;
  width: 600px;
  height: 300px;
  overflow: hidden;
  border-radius: 20px;
}
.previewBox {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.leftBox {
  width: 240px;
  height: 240px;
}
.rightBox {
  display: flex;
  flex-direction: column;
  width: 360px;
  height: 240px;
  padding: 15px;
  justify-content: space-between;
}
.topBox {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.closeEdit {
  right: 10px;
  min-height: 40px;
  min-width: 40px;
  max-height: 40px;
  max-width: 40px;
  border: none;
  border-radius: 50%;
  background-image: url("../../assets/closeEdit.svg");
  background-color: #e0e0e0;
  cursor: pointer;
  z-index: 3;
}
.closeEdit:hover {
  background-color: #cacaca;
}
.closeEdit:active {
  transform: scale(0.9);
}
.groupTitle {
  font-size: 20px;
  color: black;
  margin: 0 !important;
  font-weight: bold;
}
.groupMembers {
  font-size: 18px;
}
.groupPreviewImage {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin: 10px;
  border: 1px solid #f0f0f0;
}
.infoRow {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}
.textCol {
  width: 150px;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.joinGroupButton {
  width: 60%;
  border: none;
  color: white;
  background-color: #0988e3;
  padding: 10px;
  font-size: 20px;
  border-radius: 40px;
  cursor: pointer;
}
.joinGroupButton:hover {
  background-color: #0f6cb9;
}
.groupImage {
  width: 96%;
  height: 96%;
  margin: 2%;
  object-fit: cover;
  border-radius: 20px;
  border: thin solid lightgrey;
}
.noInterests {
  border: thin solid lightgrey;
  border-radius: 5px;
  width: 100%;
  text-align: center;
}
.interestList {
  display: flex;
  flex-wrap: wrap;
}
.joinButton {
  width: 50%;
  margin: 10px 25% 0 25%;
  height: 40px;
  color: rgb(9, 132, 227);
  background-color: #0fb9b150;
  font-weight: 600;
  font-size: 18px;
  border-radius: 10px;
  cursor: pointer;
  border: none;
  bottom: 0;
}
.joinButton:hover {
  background-color: #0fb9b190;
}
.joinButton:active {
  transform: scale(0.97);
}
</style>
